import React, {useEffect,useState} from 'react'
import { callAPI } from '../../utils/apiUtils';
import {apiUrls} from '../../utils/apiUrls';
import {HTTP_STATUS} from '../../utils/httpStatusCodes';
import { deletedLabel } from '../../utils/deletedItem';

const deletedRowStyle = { opacity: 0.55 };
const deletedNameStyle = { textDecoration: 'line-through' };
const deletedBadgeStyle = {
    fontSize: '11px',
    display: 'inline-block',
    marginTop: 4,
    padding: '2px 6px',
    borderRadius: 4,
    background: 'rgba(220, 53, 69, 0.18)',
    color: '#ff6b6b',
};

const OrderDetails = ({ orderId }) => {
    useEffect(() => {
        if(orderId){
            fetchOrderDetails(orderId);
        }
    }, [orderId]);

    const [orderDetailsData, setOrderDetailsData] = useState(null);

    const fetchOrderDetails = async (orderId) => {
        // Implement API call to fetch order details by orderId
        // For now, we just log it
        try{
            const response = await callAPI(apiUrls.ORDER_DETAILS_URL + `?id=${orderId}`, {}, 'GET');
            if(response.status === HTTP_STATUS.OK && response && response.data) {
            setOrderDetailsData(response.data.data);
            }else{
            setOrderDetailsData(null);
            console.error("Error fetching order details:", response);
            }
        } catch (error) {
            console.error("Error fetching order details:", error);
            setOrderDetailsData(null);
        }
    };
    // console.log("Order Details Data:", orderDetailsData?.order_id);

    return (
        <div className="modal modalStyle fade" id="orderDetailModal" tabIndex="-1" aria-labelledby="orderDetailModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-xl">
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title mdTitle" id="orderDetailModalLabel">Order {orderDetailsData?.order_id} Details</h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="tableSection">
                            <div className="table-responsive">
                                <table className="table tableStyle align-middle">
                                    <thead>
                                        <tr>
                                            <th colSpan="2">Item Name</th>
                                            <th>Quantity</th>
                                            <th className="text-nowrap">Item Extra Opitions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {orderDetailsData?.items && orderDetailsData.items.length > 0 ? (
                                            orderDetailsData.items.map((item, index) => {
                                                return (
                                                    <tr key={index} style={item.deleted_at ? deletedRowStyle : undefined}>
                                                        <td className="tableProImgCol">
                                                            <img src="/images/product-img-1.webp" alt="..." className="tableProImg"/>
                                                        </td>
                                                        <td>
                                                            <span className="proName d-block" style={item.deleted_at ? deletedNameStyle : undefined}>{item.name} </span>
                                                        {item.selected_size && <span className="proDetail">{item.selected_size}</span>}
                                                        {item.deleted_at && <span style={deletedBadgeStyle}>{deletedLabel(item.deleted_at)}</span>}
                                                    </td>
                                                    <td>{item.qty}</td>
                                                    <td dangerouslySetInnerHTML={{ __html: item.items_extra_options || '--' }} />
                                                </tr>
                                                )
                                            })
                                        ) : (
                                            <tr><td colSpan="4" className="text-center">No items found</td></tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            {orderDetailsData?.appliedSurchangeAmount && orderDetailsData.appliedSurchangeAmount.length > 0 && (
                                <>
                                    <div className="sbRow">
                                        <span className="totalLbl">Surcharges</span>
                                    </div>
                                    {orderDetailsData?.appliedSurchangeAmount.map((sur,index) => (
                                        <div className="sbRow" key={index}>
                                            <span className="totalLbl">{sur.charge_name}</span>
                                            <span className="totalVal"> ${sur.surcharge_amount} </span>
                                        </div>
                                    ))}
                                </>
                            )}
                            {orderDetailsData?.loyaltyPointRedeemed?.amount && orderDetailsData.loyaltyPointRedeemed?.amount > 0 && (
                                <div className="sbRow">
                                    <span className="totalLbl">Loyalty Discount</span>
                                    <span className="totalVal"> ${orderDetailsData?.loyaltyPointRedeemed?.amount} </span>
                                </div>
                            )}
                            {orderDetailsData?.offer_amount && orderDetailsData.offer_amount > 0 && (
                                <div className="sbRow">
                                    <span className="totalLbl">Offer</span>
                                    <span className="totalVal"> ${orderDetailsData?.offer_amount} </span>
                                </div>
                            )}
                            <div className="sbRow">
                                <span className="totalLbl">Total</span>
                                <span className="totalVal"> ${orderDetailsData?.total_amount} </span>
                            </div>
                        </div>
                        <div className="mt-3 mt-xl-4 mb-3 mb-lg-4 mb-xl-5 cardStyle">
                            <div className="cardHeader">
                                <h4 className="smTitle primaryColor mb-0">Customer Details:</h4>
                            </div>
                            <div className="cardBody">
                                <div className="row gx-4 gy-3">
                                    <div className="col-auto">
                                        <div className="sbRow gap-2">
                                            <span className="cLbl fw-semibold">Name:</span>
                                            <span className="cVal">{orderDetailsData?.customer_name}</span>
                                        </div>
                                    </div>
                                    <div className="col-auto">
                                        <div className="sbRow gap-2">
                                            <span className="cLbl fw-semibold">Ph. No:</span>
                                            <span className="cVal">{orderDetailsData?.customer_phone}</span>
                                        </div>
                                    </div>
                                    <div className="col-auto">
                                        <div className="sbRow gap-2">
                                            <span className="cLbl fw-semibold">Address:</span>
                                            <span className="cVal">{orderDetailsData?.customer_address}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
    }
export default OrderDetails;